import React, { lazy } from 'react';

const TaxSchemeListing = lazy(() =>
  import('./GLTaxListing').then(module => ({
    default: module.GLTaxListing,
  })),
);

const glTaxRoutes = [
  {
    props: {
      exact: true,
      path: `/company-setup/submenu/:CompanyID/company-gl-mapping/tax/:associationType`,
    },
    component: <TaxSchemeListing mode="company-setup" />,
  },
  {
    props: {
      exact: true,
      path: `/:mode/general-settings/tax/:associationType`,
    },
    component: <TaxSchemeListing />,
  },
];

export default glTaxRoutes;
